import { render, staticRenderFns } from "./EmailEditorPage.vue?vue&type=template&id=1a51ea11&scoped=true&"
import script from "./EmailEditorPage.vue?vue&type=script&lang=js&"
export * from "./EmailEditorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a51ea11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a51ea11')) {
      api.createRecord('1a51ea11', component.options)
    } else {
      api.reload('1a51ea11', component.options)
    }
    module.hot.accept("./EmailEditorPage.vue?vue&type=template&id=1a51ea11&scoped=true&", function () {
      api.rerender('1a51ea11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/EmailEditorPage.vue"
export default component.exports